export enum AttractionSourceEnum {
    EXCEL = 'excel',
    WIKIDATA = 'wikidata',
    MANUAL = 'manual',
    PLACES = 'places',
    /** Created by a partner author in the story editor. */
    PARTNER = 'partner',
    /** Created by seed / placeHints gap-fill. */
    SEED = 'seed',
    /** Candidate found by the AI city researcher (web search). */
    AI_RESEARCH = 'ai_research',
}
